module.exports = __webpack_public_path__ + "main_ru.png?d12c27b37a112d3c1e9f58c8092f3737";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_ru.png
// module id = 226
// module chunks = 0